import { Consideration } from './Consideration';

export class FurtherConsiderations  {
    considerations: Consideration[];
    
    static createFromConsiderations(considerations: Consideration[]) {
        const furtherConsiderations = new FurtherConsiderations();
        if (considerations) {
            furtherConsiderations.considerations = considerations.map((consideration) => {
                return new Consideration(consideration);
            });
        } else {
            furtherConsiderations.considerations = [];
        }
        return furtherConsiderations;
    }

    constructor(furtherConsiderations?: FurtherConsiderations) {
        // This handles copying the simple properties
        if (!furtherConsiderations) {
            return;
        }
        // This handles copying the simple properties
        Object.keys(furtherConsiderations).forEach(key => {
            this[key] = furtherConsiderations[key];
        });

        if (furtherConsiderations && furtherConsiderations.considerations) {
            this.considerations = furtherConsiderations.considerations.map((consideration) => {
                return new Consideration(consideration);
            });
        } else {
            this.considerations = [];
        }
    }

    findConsiderations?(categoryId: number, section?: string, tab?: string): Consideration[] {
        return this.considerations.filter((consideration) => {
            if (section && tab) {
                return consideration.categoryId === categoryId && 
                    consideration.section === section &&
                    consideration.tab === tab;
            } 
            return consideration.categoryId === categoryId;
        });
    }

    // TODO: If this is not used, consider deleting.  It might be useful
    // for PDF export page.
    findConsiderationsByCategoryAndSubCategory?(categoryId: number, subCategoryId: number): Consideration[] {
        return this.considerations.filter((consideration) => {
            return consideration.categoryId === categoryId &&
                consideration.subCategoryId === subCategoryId;
        });
    }
}